
export const Footer = () => {

  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        background: "#000",
        textAlign: "center",
        padding: "10px",
        marginTop: "auto",
        zIndex: 9
      }}
    >
      <p style={{ margin: 0, fontSize: "15px", fontWeight: "600",color: '#fff' }}>
        &copy; {currentYear} The Coca-Cola Company. All rights reserved.
      </p>
    </footer>
  );
};
